import { Component, Input, OnInit, ViewEncapsulation, Optional } from '@angular/core';
import { WindowRef } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';
import { DeleteMessageBarInfo, DeleteMessageType } from './delete-message.model';
import { DeleteMessageDetails, DeleteMessageDetail, DeleteDetailTypeIcons, DeleteDetailState } from './delete-message-detail.model';
import { LogService } from 'src/app/log.service';

@Component({
  selector: 'file360-header-bar-message-delete',
  templateUrl: './header-bar-message-delete.component.html',
  styleUrls: ['./header-bar-message-delete.component.scss',
    '../../kendo-overrides.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderBarMessageDeleteComponent implements OnInit {

  DeleteDetailTypeIcons = DeleteDetailTypeIcons;
  DeleteDetailState = DeleteDetailState;
  DeleteMessageType = DeleteMessageType;

  /**
   * Header bar information 
   */
  @Input() hbi: DeleteMessageBarInfo = new DeleteMessageBarInfo("", DeleteMessageType.Progress);
  /**
   * Header bar detail information
   */
  @Input() deletes: DeleteMessageDetails = new DeleteMessageDetails(this.logService, new Subject<string>());

  constructor(@Optional() private windowRef: WindowRef, private logService: LogService) {
  }

  ngOnInit() {
  }

  /**
   * Stop a delete
   */
  stop(deleteDetail: DeleteMessageDetail) {
    this.logService.logMessage(`HeaderBarMessageDeleteComponent:stop ${deleteDetail.uniqueId} enter.`);
    deleteDetail.stop();
    this.deletes.stopDeleteRequested = true;
    this.deletes.deletingCount--;
  }

  /**
   * Stop all currently waiting deletes
   */
  stopAll() {
    this.logService.logMessage('HeaderBarMessageDeleteComponent:stopAll enter.');
    this.deletes.stopAll();
  }

  onCaret() {
    if (this.hbi.showCaretUp) {
      this.hbi.showCaretDown = true;
      this.hbi.showCaretUp = false;

    } else {
      this.hbi.showCaretDown = false;
      this.hbi.showCaretUp = true;
    }
  }

  get isExpanded() {
    return this.hbi.showCaretUp || this.hbi.isExpanded;
  }

  /**
   * Close the header bar message
   */
  onClose() {
    let msg: string = "HeaderBarMessageComponent : onClose - " + this.hbi.message;
    this.logService.logMessage(msg);
    this.windowRef.close();
  }

  /**
   * Get the ngClass-formatted structure that applies the CSS style name
   * for the message type of this message. 
   */
  get messageClass() {
    return {
      "ot-message-warning": this.hbi.messageType == DeleteMessageType.Warning,
      "ot-message-confirmation": this.hbi.messageType == DeleteMessageType.Done,
      "ot-message-status": this.hbi.messageType == DeleteMessageType.Progress,
      "ot-collapsed": !this.isExpanded
    }
  }

  showStop() {
    return this.deletes.details.findIndex(d => d.state == DeleteDetailState.Waiting) >= 0;
  }
}

